import { Controller } from "@hotwired/stimulus"

// Connects to data-controller="payment-method"
export default class extends Controller {
  static targets = [
    "radio",
    "option",
    "selectedPaymentMethod",
    "paymentTypeField",
    "paymentTypeText",
  ]

  static values = {
    paymentLabel: String,
    automaticLabel: String,
    directLabel: String,
    invoiceLabel: String,
    invoiceConfirmation: String,
  }

  connect() {
    this.updateActiveClass(this.currentValue)
  }

  select(event) {
    const selectedValue = event.target.value
    if (!selectedValue) return

    if (this.hasSelectedPaymentMethodTarget) {
      this.selectedPaymentMethodTarget.value = selectedValue
    }
    if (this.hasPaymentTypeFieldTarget) {
      this.paymentTypeFieldTarget.value = selectedValue
    }

    this.updateActiveClass(selectedValue)
    this.updatePaymentTypeText(selectedValue)
  }

  confirmInvoice(event) {
    if (event.target.value !== "invoice") return

    const confirmation = confirm(this.invoiceConfirmationValue)
    if (!confirmation) {
      event.preventDefault()
      event.target.checked = false
      this.updateActiveClass(null)
    }
  }

  updateActiveClass(selectedValue) {
    this.optionTargets.forEach((wrapper) => {
      const radio = wrapper.querySelector("input[type=radio]")
      if (radio?.value === selectedValue) {
        wrapper.classList.add("bg-sky-50", "border-sky-500")
      } else {
        wrapper.classList.remove("bg-sky-50", "border-sky-500")
      }
    })
  }

  updatePaymentTypeText(paymentType) {
    if (!this.hasPaymentTypeTextTarget) return
    const translatedPaymentType = this.getPaymentTypeLabel(paymentType)
    this.paymentTypeTextTarget.textContent = `${this.paymentLabelValue}: ${translatedPaymentType}`
  }

  getPaymentTypeLabel(paymentType) {
    switch (paymentType) {
      case "automatic":
        return this.automaticLabelValue
      case "direct":
        return this.directLabelValue
      case "invoice":
        return this.invoiceLabelValue
      default:
        return paymentType
    }
  }

  get currentValue() {
    return this.radioTargets.find((radio) => radio.checked)?.value
  }
}
